import type { Documento } from '@hooks/useDocumentos.js'

export type ViewMode = 'gallery' | 'list'

export type DocItem = Documento & { id: number }

export type FormState = {
  nome: string
  categoria: string
  data: string
  fornecedor: string
  valor: string
  observacoes: string
  moduloId: string
  lancamentoId: string
  tipo: string
  tamanho: number
  arquivo: Blob | File | null
  previewObjectUrl: string
  hasExistingArquivo: boolean
  sourceDocId?: number
}

export const EMPTY_FORM: FormState = {
  nome: '',
  categoria: '',
  data: new Date().toISOString().slice(0, 10),
  fornecedor: '',
  valor: '',
  observacoes: '',
  moduloId: '',
  lancamentoId: '',
  tipo: '',
  tamanho: 0,
  arquivo: null,
  previewObjectUrl: '',
  hasExistingArquivo: false,
}

export const PASTAS_CONFIG: { cat: string; sigla: string }[] = [
  { cat: 'Notas Fiscais', sigla: 'NF' },
  { cat: 'Fotos de Obra', sigla: 'FT' },
  { cat: 'Contratos', sigla: 'CT' },
  { cat: 'Projetos', sigla: 'PR' },
  { cat: 'Laudos', sigla: 'LD' },
  { cat: 'Documentos Legais', sigla: 'LG' },
]
